<template>
  <div>
    <div class="doctor-list">
      <div class="doctor-item" v-for="(item,index) in list" :key="index" @click="toDoctorDetail(item.doctorCode)">
        <div class="doctor-box">
          <div class="card-item">
            <div class="head-box">
              <img src="@/assets/head.jpg" alt="头像" />
            </div>
            <div class="head-name-detail">
              <div class="detail-item">
                <span class="name">{{item.doctorname}}</span>
              </div>
              <div class="detail-item">挂号级别：{{item.doctortitle}}</div>
              <div class="detail-item">出诊科室：{{item.outpatientSectionName}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { findDoctorBySectionOrName } from '@/api/api'
export default {
  name: 'selectDoctor',
  data() {
    return {
      list:[]
    }
  },
  created() {},
  mounted() {
    this.getData()
  },
  methods: {
    getData(){
      findDoctorBySectionOrName(this.$route.query.name).then(res=>{
        this.list = res.data
      })
    },
    toDoctorDetail(code) {
      this.$router.push({
        name:'doctorDetail',
        query:{
          docCode:code
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.dept-title {
  width: 100%;
  height: 40px;
  line-height: 40px;
  font-size: 15px;
  padding: 0 10px;
  border-top: 1px solid #ebedf0;
  border-bottom: 1px solid #ebedf0;
}
.week-box {
  width: 100%;
  overflow-x: auto;
  height: 70px;
  border-bottom: 1px solid #ebedf0;
  display: flex;
}
.doctor-list {
  height: 100vh;
  max-height: 100vh;
  overflow-y: auto;
  width: 100vw;
  padding: 10px;
  background: rgb(242, 248, 243);
  .doctor-item {
    width: 100%;
    height: 80px;
    background: #fff;
    box-shadow: 3px 0 9px #ebedf0;
    padding: 10px;
    font-size: 13px;
    margin-bottom: 10px;
    .doctor-box {
      width: 100%;
      height: 55px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .card-item {
        width: 100%;
        height: 55px;
        padding: 5px 10px;
        display: flex;
        align-items: center;
        .head-box {
          width: 40px;
          height: 40px;
          img {
            width: 40px;
            height: 40px;
            border-radius: 20px;
          }
        }
        .head-name-detail {
          width: calc(100% - 50px);
          .detail-item {
            width: 100%;
            height: 22.5px;
            display: flex;
            align-items: flex-end;
            padding-left: 10px;
            color: #666;
            font-size: 12px;
            .name {
              font-size: 15px;
              padding-right: 10px;
              color: #000;
            }
            .status {
              padding: 2px 5px;
              color: #fff;
              border-radius: 3px;
              margin-left: 10px;
            }
            .color-blue {
              background: #3478f7;
            }
            .color-red {
              background: red;
            }
          }
        }
      }
    }
    .doctor-num {
      width: 100%;
      height: 28px;
      display: flex;
      align-items: center;
      padding-left: 10px;
      justify-content: space-between;
      .bet {
        .much {
          font-size: 12px;
          color: rgb(237, 125, 84);
          padding-right: 5px;
        }
      }
    }
  }
}
</style>
